const initialState = () => ({
  organizations: [],
  newOrganizations: [],
  pagination: {},
  newFranchises: [],
  userByFranchises: [],
  enabledFranchise: null,
  sectors: [],
  settings: {
    alt_franchise_name: null,
    action_plan_priorities: [{
      value: 1,
      label: 'Baja',
      color: 'green',
      time: 0,
      unit: 'd'
    }, {
      value: 2,
      label: 'Media',
      color: 'amber',
      time: 0,
      unit: 'd'
    }, {
      value: 3,
      label: 'Alta',
      color: 'red',
      time: 0,
      unit: 'd'
    }],
    ap_categories: [],
    ap_categories2: [],
    form_categories: [],
    item_responsabilities: [],
    item_leaderships: [],
    rol_location_responsable: null,
    // Keyed by 1-based location group level (e.g. { 1: 'Región', 2: 'Estado' }),
    // not a fixed top/middle/bottom shape - a location group tree can be any depth.
    location_group_names: {},
    form_goals: [],
    available_reports: [],
    score_scale: null,
    demo_expires: ''
  },
  status: false
})

export default initialState
